export const INTERCOM_TARGET_PREFIX = 'createChallenge';

export const BLANK_CHALLENGE_THEME_NAME = 'blank';

export const DEFAULT_TIME_LIMIT = {
    maxBuzzes: 3,
    interval: 15,
    unit: 'Minutes',
    timePeriodSeconds: 900,
};
